import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card p-2 w-100" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "mb-2 me-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_5 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "tag-name" }, " Name ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "tag-description" }, " Description ", -1 /* HOISTED */)
const _hoisted_12 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, _hoisted_7)), [
          [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.tagsTooltip) }]
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          name: "tag-name",
          class: "form-control w-40",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tagName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.tagName]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          name: "tag-description",
          id: "tag-description",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tagDescription) = $event)),
          rows: "6",
          maxlength: "5000"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.tagDescription]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary me-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ok()))
      }, "Save"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel()))
      }, "Cancel")
    ])
  ]))
}